/* eslint-disable no-useless-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import { Button, Container, CssBaseline, Grid } from '@mui/material';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import useStyles from '../../../../assets/styles/pages/ShopRequest';
import Header from '../../../../components/Header';

// import svg
import { ReactComponent as IconWallet } from '../../../../assets/images/svg/shops/request/icon_carteira.svg';
import { ReactComponent as IconCoupon } from '../../../../assets/images/svg/shops/request/icon_cupom.svg';
import { ReactComponent as IconLocation } from '../../../../assets/images/svg/shops/request/icon_local.svg';
import { ReactComponent as IconArrowRight } from '../../../../assets/images/svg/shops/request/icon_seta_direita.svg';
import { ReactComponent as IconCoupon1 } from '../../../../assets/images/svg/shops/request/icon_cupom_1.svg';
import { ReactComponent as IconRight } from '../../../../assets/images/svg/shops/request/Vector.svg';
import { ReactComponent as IconPlus1 } from '../../../../assets/images/svg/shops/request/button_mais.svg';
import { ReactComponent as IconLess } from '../../../../assets/images/svg/shops/request/button_menos.svg';
import { ReactComponent as IconObservation } from '../../../../assets/images/svg/shops/request/icon_observacao.svg';
import imgCpf from '../../../../assets/images/cpf.png';
import imgCashbackIcon from '../../../../assets/images/cashbackicon.png';

import {
  getStorege,
  removeStorege,
  saveStorege,
} from '../../../../helpers/db_storage';
import {
  FormatCpf,
  FormatPrice,
  onlyNumbers,
  parseCurrencyBRToFloat,
  validateCpf,
} from '../../../../helpers/utils/Formating';
import { api } from '../../../../services';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { useSignInContext } from '../../../../providers/use-signin';
import { useShopContext } from '../../../../providers/use-shop';
import { checkCartStorege } from '../../../../helpers/utils/Check';
import { useLoadingContext } from '../../../../providers/use-loading';
import ModalConfirmFooter from '../../../../components/Modal/ConfirmFooter';
import ModalInputFooter from '../../../../components/Modal/InputFooter';
import ModalImgBackgroundFooter from '../../../../components/Modal/ImgBackgroundFooter';
import { SuccessRequestModal } from '../../../../components/Modal/SuccessOrderModal';
import { ConfirmOrderModal } from '../../../../components/Modal/ConfirmOrderModal';
import { AddItemCartModal } from '../../../../components/Modal/AddItemCartModal';
import { TypeDeliveryModal } from '../../../../components/Modal/TypeDeliveryModal';
import { ListCenterOrder } from '../../../../components/Modal/ListCenterOrder';
import ModalInput from '../../../../components/Modal/Input';
import { ModalMessage } from '../../../../components/Modal/Message';
import { useTrackingContext } from '../../../../context/TrackingContext';
import OrderDataRegister from '../../../../components/Modal/OrderDataRegister';

const Cart: React.FC = () => {
  const classeStyle = useStyles();
  const siginContext = useSignInContext();
  const shopContext = useShopContext();
  const navigate = useNavigate();
  const { idRestaurante }: any = useParams();
  const { createloading } = useLoadingContext();
  const { trackEvent } = useTrackingContext();

  const [products, setProducts] = useState<any>();
  const [dataRequest, setDataRequest] = useState<any>({
    idUsuario: '',
    idRestaurante: shopContext.data.shop?.idRestaurante,
    vlPedido: null,
    vlEntrega: 0,
    vlEntregaOriginal: 0,
    vlFaltaFreteGratis: 0,
    vlDesconto: 0,
    dsObservacaoLocal: '',
    idEndereco: 0,
    dsEntrega: '',
    idEntrega: null,
    idPagamento: null,
    dsPagamento: '',
    dsTpChavePix: '',
    dsChavePix: '',
    flgPix: 0,
    dsTroco: '',
    vlTroco: null,
    flgFreteGratis: null,
    flgFreteGratisCupom: null,
    idCupom: null,
    dsCupom: null,
    dsMensagemCupom: null,
    vlCupom: 0,
    flgAgendamento: null,
    dtAgendamento: null,
    dtCriacao: new Date(),
    idPagamentoForma: null,
    dsCpf: '',
    noLogin: false,
  });
  const [dataUserOrder, setDataUserOrder] = useState<any>();
  const [productParamDelete, setProductParamDelete] = useState<any>();
  const [addresses, setAddresses] = useState<any>();
  const [typeDelivery, setTypeDelivery] = useState<any>();
  const [haveCoupon, setHaveCoupon] = useState<any>();
  const [listCoupon, setListCoupon] = useState<any>([]);
  const [haveIsPromotion, setHaveIsPromotion] = useState<boolean>(false);
  const [typePayment, setTypePayment] = useState<[]>([]);
  const [configShop, setConfigShop] = useState<any>();
  const [cashBackBalance, setCashBackBalance] = useState<any>();
  const [cpf, setCpf] = useState('');

  const [desNameBtnSend, setDesNameBtnSend] = useState<string>('Enviar pedido');

  const [openModalConfirmRequest, setOpenModalConfirmRequest] = useState(false);
  const [openModalInsertCoupom, setOpenModalInsertCoupom] = useState(false);
  const [openModalListCoupom, setOpenModalListCoupom] = useState(false);
  const [openModalAddressSelect, setOpenModalAddressSelect] = useState(false);
  const [openModalTypeDelivery, setOpenModalTypeDelivery] = useState(false);
  const [openModalFormatPayment, setOpenModalFormatPayment] = useState(false);
  const [openModalSuccessRequest, setOpenModalSuccessRequest] = useState(false);
  const [textModal, setTextModal] = useState<any>({
    title: '',
    description: '',
    action: false,
  });
  const [openUserNotParams, setOpenUserNotParams] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openModalAddItem, setOpenModalAddItem] = useState(false);
  const [errorInfo, setErrorInfo] = useState('');
  const [openModalConfirmAction, setOpenModalConfirmAction] = useState(false);
  const [msgnModalConfirmAction, setMsgModalConfirmAction] = useState({
    title: 'Atenção',
    messagem: '',
    action: 0,
  });
  const [useFn, setUseFn] = useState(true);
  const [showModalFreeDelivery, setShowModalFreeDelivery] = useState(true);
  const [showModalDistrictNoFreeDelivery, setShowModalDistrictNoFreeDelivery] =
    useState(true);
  const [idRequest, setIdRequest] = useState('');
  const [openModalFooterInput, setOpenModalFooterInput] = useState(false);
  const [dataModalFooterInput, setDataModalFooterInput] = useState<any>({
    title: 'Atenção',
    message: '',
    action: 0,
    placeholder: '',
    btnConfirm: 'Confirmar',
    btnCancel: 'Voltar',
    type: '',
    icon: '' as any,
    img: '',
  });
  const [openModalFooterBenefit, setOpenModalFooterBenefit] = useState(false);
  const [openModalConfirmMajority, setOpenModalConfirmMajority] =
    useState(false);
  const [confirmMajority, setConfirmMajority] = useState(false);
  const [openModalChoosePaymentMethod, setOpenModalChoosePaymentMethod] =
    useState(false);
  const [openModalOrderRegister, setOpenModalOrderRegister] = useState(false);

  const handleToPage = (url: string): any => {
    return navigate(url, { replace: true });
  };

  const handleModalInputFooter = (isOpen = false, type = 'troco'): void => {
    if (!isOpen) {
      setDataModalFooterInput({
        title: '',
        message: '',
        action: 0,
        placeholder: '',
        btnConfirm: 'Confirmar',
        btnCancel: 'Voltar',
        type: '',
        icon: '',
        img: '',
      });
    }
    setOpenModalFooterInput(isOpen);

    switch (type) {
      case 'cpf':
        setDataModalFooterInput({
          title: 'CPF',
          message: 'Informe seu CPF',
          action: 0,
          placeholder: 'Digite seu CPF',
          btnConfirm: 'Confirmar',
          btnCancel: 'Voltar',
          type,
          icon: '',
          img: imgCpf,
        });
        break;

      default:
        setDataModalFooterInput({
          title: 'Troco pra quanto?',
          message:
            'Digite quannto vai pagar em dinheiro para o troco ser definido:',
          action: 0,
          placeholder: 'Informe valor',
          btnConfirm: 'Confirmar',
          btnCancel: 'Não preciso de troco',
          type,
          icon: <IconWallet width={35} height={35} />,
          img: '',
        });
        break;
    }
  };

  const checkUserAutentication = (): boolean => {
    if (!siginContext.signed) {
      toast.info(
        'Para concluir seu pedido você precisa está logado, por favor efetue o login',
      );
      handleToPage(
        `/sign/in/${window.btoa('requestProgress')}/${idRestaurante}`,
      );

      return false;
    }

    return true;
  };

  const handleListAddress = async (): Promise<boolean> => {
    const isUserAuthenticated = checkUserAutentication();

    if (!isUserAuthenticated) {
      return false;
    }
    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.listAddress({
          nr_operacao: 10,
          idUsuario: siginContext.data.user?.idUsuario,
        });
      setAddresses(result.data);
      createloading(false);
      return true;
    } catch (error: any) {
      createloading(false);
      if (error.response.status === 401) {
        siginContext.signingOut({
          http_status: 401,
          location: 'requestDetail',
          id_shop: idRestaurante,
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error('Ocorreu um erro ao listar os endereços');
      }
      return false;
    }
  };

  const handleSetQtProduct = (
    id: number,
    id_pedido_cardapio: number,
    qt: number,
    id_promotion: number,
    promotion_max_stage: number,
  ): void => {
    const productSelected = products?.pedido_cardapio.findIndex(
      (productData: any) =>
        Number(productData.idCardapio) === Number(id) &&
        Number(productData.idPedidoCardapio) === Number(id_pedido_cardapio),
    );

    if (qt >= 1) {
      if (id_promotion && promotion_max_stage > 1) {
        setTextModal({
          title: 'Atenção',
          description:
            'Para comprar mais deste item volte para aba de promoções',
        });
        setOpenErrorModal(true);
        return;
      }
      const productQt = products;
      setProducts(['']);

      productQt.pedido_cardapio[productSelected].qtItens = qt;

      setProducts(() => {
        return {
          ...productQt,
        };
      });
      saveStorege('@mais/delivery/shop/request/product/cart', productQt);
    } else {
      setProductParamDelete(productSelected);
      if (id_promotion) {
        setErrorInfo(
          'Este item faz parte de uma promoção. Se excluir, irá excluir todos os itens. Confirmar?',
        );
      } else {
        setErrorInfo('Realmente deseja retirar este item?');
      }
      setOpenUserNotParams(true);
    }
  };

  const handleDeleteItemProduct = (productSelected: number): void => {
    const resultItemProduct = products?.pedido_cardapio[productSelected];
    if (resultItemProduct?.idPromocao) {
      removeStorege('@mais/delivery/shop/request/product/cart');
      removeStorege('@mais/delivery/shop/request/data/cart');
      removeStorege('@mais/delivery/shop/request/product/promotion');
      removeStorege('@mais/delivery/shop/request/cart/filter/payment');
      navigate(-1);
      return;
    }

    products?.pedido_cardapio.splice(productSelected, 1);
    saveStorege('@mais/delivery/shop/request/product/cart', products);

    setProducts(() => {
      return {
        ...products,
      };
    });
    setOpenUserNotParams(false);
    if (products?.pedido_cardapio.length === 0) {
      removeStorege('@mais/delivery/shop/request/product/cart');
      removeStorege('@mais/delivery/shop/request/data/cart');
      removeStorege('@mais/delivery/shop/request/product/promotion');
      removeStorege('@mais/delivery/shop/request/cart/filter/payment');
      navigate(-1);
    }
  };

  const handleSetDataRequest = (
    name: string,
    value: any,
    openModal = true,
  ): void => {
    if (name === 'removeLocation') {
      setDataRequest((field: any) => {
        return {
          ...field,
          idEntrega: 2,
          idEndereco: 0,
          vlEntrega: 0,
          dsEntrega: value,
        };
      });
      setOpenModalTypeDelivery(false);
      return;
    }

    if (name === 'delivery') {
      setShowModalDistrictNoFreeDelivery(true);
      if (dataRequest.idEndereco != value.idEndereco || dataRequest.noLogin) {
        setDataRequest((field: any) => {
          return {
            ...field,
            idEntrega: 1,
            vlEntrega: value.vlEntrega,
            idEndereco: value.idEndereco,
            dsEntrega: value.dsEntrega,
          };
        });
      }
      setOpenModalAddressSelect(false);
      return;
    }
    if (name === 'typePayment') {
      if (value.idPagamentoForma != 2 && !dataRequest.noLogin) {
        setDesNameBtnSend('Pagar');
      } else if (!dataRequest.noLogin) {
        setDesNameBtnSend('Enviar pedido');
      }

      setDataRequest((field: any) => {
        return {
          ...field,
          flgPix: value.flgPix,
          idPagamento: value.idPagamento,
          dsPagamento: value.dsPagamento,
          dsTpChavePix: value.dsTpChavePix,
          dsChavePix: value.dsChavePix,
          idPagamentoForma: value.idPagamentoForma,
        };
      });
      setOpenModalFormatPayment(false);
      if (value.dsPagamento == 'Dinheiro' || value.dsPagamento == 'dinheiro') {
        handleModalInputFooter(openModal, 'troco');
      }
      if (value.dsPagamento != 'Dinheiro') {
        setDataRequest((field: any) => {
          return {
            ...field,
            dsTroco: '',
            vlTroco: null,
          };
        });
      }
      return;
    }
    if (name === 'dsTroco') {
      if (value == -1) {
        setDataRequest((field: any) => {
          return {
            ...field,
            dsTroco: '(Não preciso de troco)',
            vlTroco: value,
          };
        });
        return;
      }
      const total =
        parseFloat(dataRequest.vlPedido) + parseFloat(dataRequest.vlEntrega);
      if (!value || value == '' || isNaN(value)) {
        toast.error(`Informe um valor válido para troco`);
        return;
      }
      if (parseFloat(value) < total) {
        toast.error(
          `O valor do troco deve ser maior ao valor total do pedido (R$ ${FormatPrice(
            total,
          )}).`,
        );
        return;
      }
      setDataRequest((field: any) => {
        return {
          ...field,
          dsTroco: `(Troco para R$ ${FormatPrice(value)})`,
          vlTroco: FormatPrice(value),
        };
      });
      handleModalInputFooter(false, `troco`);
      return;
    }
    if (name === 'dsCpf') {
      if (!value || value == '') {
        setTextModal({
          title: 'Atenção',
          description: 'Informe um CPF valido',
        });
        setOpenErrorModal(true);
        return;
      }
      if (!validateCpf(onlyNumbers(value))) {
        setTextModal({
          title: 'Atenção',
          description: 'CPF inválido',
        });
        setOpenErrorModal(true);
        return;
      }
      setDataRequest((field: any) => {
        return {
          ...field,
          dsCpf: onlyNumbers(value),
        };
      });
      handleModalInputFooter(false, 'cpf');
      return;
    }
    setDataRequest((field: any) => {
      return {
        ...field,
        [`${name}`]: value,
      };
    });
  };

  const callbackModalInputFooter = (value: any, type: string): void => {
    switch (type) {
      case 'troco':
        handleSetDataRequest('dsTroco', value);
        break;
      case 'cpf':
        setCpf(value);
        handleSetDataRequest('dsCpf', value);
        break;
      default:
        break;
    }
  };

  const handleShowModalAddress = async (): Promise<void> => {
    const isUserAuthenticated = checkUserAutentication();

    if (!isUserAuthenticated) {
      return;
    }
    const result = await handleListAddress();
    setOpenModalTypeDelivery(false);

    if (result) {
      setOpenModalAddressSelect(true);
    }
  };

  const handleShowModalCoupom = (param: number): void => {
    const isUserAuthenticated = checkUserAutentication();

    if (!isUserAuthenticated) {
      return;
    }
    if (param === 1) {
      if (listCoupon.length > 0) {
        setOpenModalListCoupom(true);
        return;
      }
      setOpenModalInsertCoupom(true);
    }

    if (param === 2) {
      setOpenModalListCoupom(false);

      setOpenModalInsertCoupom(true);
    }
  };

  const handleTypeDeliveryExec = (type: number): void => {
    if (type == 1 && !dataRequest.noLogin) {
      handleListAddress();
      handleShowModalAddress();
      return;
    }
    if (type == 1 && dataRequest.noLogin) {
      setDataUserOrder((field: any) => {
        return {
          ...field,
          complet: '',
          idEndereco: 0,
          dsRua: '',
          nrRua: '',
        };
      });
      handleSetDataRequest('delivery', {
        vlEntrega: 0,
        idEndereco: 0,
        dsEntrega: `Receber em casa`,
      });
      return;
    }
    if (type == 2) {
      handleSetDataRequest('removeLocation', 'Retirar no balcão');
      return;
    }

    if (type == 3) {
      setOpenModalTypeDelivery(true);
    }
  };

  const handleSelectTypeDelievry = (
    type: number,
    verifyCoupon = true,
  ): void => {
    if (
      verifyCoupon &&
      (dataRequest.idEntregaCupom == 1 || dataRequest.idEntregaCupom == 2)
    ) {
      if (dataRequest.idEntregaCupom != type) {
        const titleTypeMsg =
          dataRequest.idEntregaCupom == 1 ? 'Entrega' : 'Balcão';
        setOpenModalConfirmAction(true);
        setMsgModalConfirmAction({
          title: 'ENTREGA',
          messagem: `Esse cupom é para ${titleTypeMsg}. Deseja mudar? Ao confirmar, o cupom será removido.`,
          action: type,
        });
        setOpenModalTypeDelivery(false);
        return;
      }
    }

    if (type === 1 && !dataRequest.noLogin) {
      handleShowModalAddress();
    } else if (type === 1 && dataRequest.noLogin) {
      setDataUserOrder((field: any) => {
        return {
          ...field,
          complet: '',
          idEndereco: 0,
          dsRua: '',
          nrRua: '',
        };
      });
      setDesNameBtnSend('Continuar');
      handleSetDataRequest('delivery', {
        vlEntrega: 0,
        idEndereco: 0,
        dsEntrega: `Receber em casa`,
      });
      setOpenModalTypeDelivery(false);
    }

    if (type === 2) {
      handleSetDataRequest('removeLocation', 'Retirar no balcão');
    }
  };

  const handleTreatRequestInit = (): void => {
    if (!dataRequest.noLogin) {
      const isUserAuthenticated = checkUserAutentication();

      if (!isUserAuthenticated) {
        return;
      }
    }

    if (configShop[0].vlMinimo.replace(',', '.') > dataRequest.vlPedido) {
      setTextModal({
        title: 'Informação',
        description: `O valor do pedido está abaixo do mínimo de R$${configShop[0].vlMinimo}`,
      });
      setOpenErrorModal(true);
      return;
    }

    if (dataRequest.dsEntrega == '') {
      handleTypeDeliveryExec(typeDelivery);
      return;
    }
    if (dataRequest.dsPagamento == '') {
      setOpenModalFormatPayment(true);
      return;
    }
    if (
      dataRequest.dsTroco == '' &&
      (dataRequest.dsPagamento == 'Dinheiro' ||
        dataRequest.dsPagamento == 'dinheiro')
    ) {
      handleModalInputFooter(true, 'troco');
      return;
    }

    if (
      configShop?.length > 0 &&
      parseInt(configShop[0]?.flgCpfObrigato, 10) === 1 &&
      !dataRequest.dsCpf
    ) {
      handleModalInputFooter(true, 'cpf');

      return;
    }

    const productSelectedMajority = products?.pedido_cardapio.findIndex(
      (productData: any) => Number(productData.flgMaiorIdade) === 1,
    );

    if (productSelectedMajority != -1 && !confirmMajority) {
      setOpenModalConfirmMajority(true);
      return;
    }

    if (
      cashBackBalance?.retorno == 'OK' &&
      cashBackBalance?.idExtrato &&
      !dataRequest.idCupom
    ) {
      setOpenModalFooterBenefit(true);
      return;
    }

    if (
      dataRequest.noLogin &&
      (!dataUserOrder?.dsNome || !dataUserOrder?.complet)
    ) {
      setOpenModalOrderRegister(true);
      return;
    }

    setOpenModalConfirmRequest(true);
  };

  const handleSendRequestNoLogin = async (): Promise<void> => {
    setOpenModalConfirmRequest(false);
    createloading(true);
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.sendRequest(
        {
          nr_operacao: 81,
          idUsuario: siginContext.data.user?.idUsuario,
          idMarketplace: shopContext.data.shop.idMarketplace,
          dsCidade: shopContext.data.shop.dsCidade,
          usuario: dataUserOrder,
          pedido: {
            dsObservacao: dataRequest.dsObservacaoLocal,
            ...dataRequest,
            idRestaurante: shopContext.data.shop.idRestaurante,
          },
          pedido_cardapio: products.pedido_cardapio,
          sabor: products.sabor,
          adicional: products.adicional,
          opcoes: products.opcoes,
        },
      );
      if (result.data?.retorno == 'OK') {
        removeStorege('@mais/delivery/shop/request/product/cart');
        removeStorege('@mais/delivery/shop/request/product/treat');
        removeStorege('@mais/delivery/shop/request/product/promotion');
        removeStorege('@mais/delivery/shop/request/cart/filter/payment');
        removeStorege('@mais/delivery/shop/request/data/cart');

        const total =
          parseFloat(dataRequest.vlPedido) + parseFloat(dataRequest.vlEntrega);

        trackEvent('Purchase', {
          value: total,
        });

        saveStorege('@mais/delivery/authorization/orders', {
          token: result.data.token,
          idUsuario: result.data?.idUsuario,
        });

        if (dataRequest.idPagamentoForma == 3) {
          saveStorege('@mais/delivery/shop/datapply', result.data);
          handleToPage(
            `/dashboard/user/request/detail/${window.btoa(
              result.data.idPedido,
            )}/${idRestaurante}`,
          );
          return;
        }
        if (dataRequest.idPagamentoForma == 1) {
          saveStorege('@mais/delivery/shop/datapply', result.data);
          const link = document.createElement('a');
          link.href = `/painel/datapaymentcardbrick.php?id=${window.btoa(
            result.data.idPedido,
          )}&origin=${window.btoa('pwa')}`;
          link.rel = 'noopener noreferrer';
          document.body.appendChild(link);
          link.click();
          return;
        }
        setIdRequest(result.data.idPedido);

        if (dataRequest.flgPix != 1) {
          setOpenModalSuccessRequest(true);
          await new Promise((resolve) => {
            setTimeout(resolve, 5000);
          });
        }
        if (dataRequest.flgPix == 1) {
          handleToPage(
            `/dashboard/user/request/detail/upload/file/pix/${window.btoa(
              result.data.idPedido,
            )}/${idRestaurante}/true`,
          );
          return;
        }
        handleToPage('/dashboard/user/request');
        return;
      }
      if (result.data?.retorno == 'NOK' && result.data?.mensagem != '') {
        setTextModal({
          title: 'Atenção',
          description: result.data?.mensagem,
        });
        setOpenErrorModal(true);
        return;
      }
      toast.error('Ocorreu um erro ao enviar seu pedido, tente novamente');
    } catch (error: any) {
      toast.error('Ocorreu um erro ao enviar seu pedido, tente novamente');
    } finally {
      createloading(false);
    }
  };

  const handleSendRequest = async (): Promise<void> => {
    if (dataRequest.noLogin) {
      await handleSendRequestNoLogin();
      return;
    }
    const isUserAuthenticated = checkUserAutentication();

    if (!isUserAuthenticated) {
      return;
    }

    setOpenModalConfirmRequest(false);
    createloading(true);
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.sendRequest(
        {
          nr_operacao: 3,
          idUsuario: siginContext.data.user?.idUsuario,
          idMarketplace: shopContext.data.shop.idMarketplace,
          dsCidade: shopContext.data.shop.dsCidade,
          pedido: {
            dsObservacao: dataRequest.dsObservacaoLocal,
            ...dataRequest,
          },
          pedido_cardapio: products.pedido_cardapio,
          sabor: products.sabor,
          adicional: products.adicional,
          opcoes: products.opcoes,
        },
      );
      if (result.data?.retorno == 'OK') {
        if (
          !siginContext.data.user?.dsCpf &&
          configShop?.length > 0 &&
          parseInt(configShop[0]?.flgCpfObrigato, 10) === 1
        ) {
          await siginContext.getDataUser(
            siginContext.data.user?.idUsuario,
            false,
          );
        }

        removeStorege('@mais/delivery/shop/request/product/cart');
        removeStorege('@mais/delivery/shop/request/product/treat');
        removeStorege('@mais/delivery/shop/request/product/promotion');
        removeStorege('@mais/delivery/shop/request/cart/filter/payment');
        removeStorege('@mais/delivery/shop/request/data/cart');

        const total =
          parseFloat(dataRequest.vlPedido) + parseFloat(dataRequest.vlEntrega);

        trackEvent('Purchase', {
          value: total,
        });

        if (dataRequest.idPagamentoForma == 3) {
          saveStorege('@mais/delivery/shop/datapply', result.data);
          handleToPage(
            `/dashboard/user/request/detail/${window.btoa(
              result.data.idPedido,
            )}/${idRestaurante}`,
          );
          return;
        }
        if (dataRequest.idPagamentoForma == 1) {
          saveStorege('@mais/delivery/shop/datapply', result.data);
          const link = document.createElement('a');
          link.href = `/painel/datapaymentcardbrick.php?id=${window.btoa(
            result.data.idPedido,
          )}&origin=${window.btoa('pwa')}`;
          link.rel = 'noopener noreferrer';
          document.body.appendChild(link);
          link.click();
          return;
        }
        setIdRequest(result.data.idPedido);

        if (dataRequest.flgPix != 1) {
          setOpenModalSuccessRequest(true);
          await new Promise((resolve) => {
            setTimeout(resolve, 5000);
          });
        }
        if (dataRequest.flgPix == 1) {
          handleToPage(
            `/dashboard/user/request/detail/upload/file/pix/${window.btoa(
              result.data.idPedido,
            )}/${idRestaurante}/true`,
          );
          return;
        }
        handleToPage('/dashboard/user/request');
        return;
      }
      if (result.data?.retorno == 'NOK' && result.data?.mensagem != '') {
        setTextModal({
          title: 'Atenção',
          description: result.data?.mensagem,
        });
        setOpenErrorModal(true);
        return;
      }
      toast.error('Ocorreu um erro ao enviar seu pedido, tente novamente');
    } catch (error: any) {
      if (error.response.status === 401) {
        siginContext.signingOut({
          http_status: 401,
          location: 'requestDetail',
          id_shop: idRestaurante,
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error('Ocorreu um erro ao enviar seu pedido, tente novamente');
      }
    } finally {
      createloading(false);
    }
  };

  const handleGetParamsShop = async (): Promise<void> => {
    const filterPaymentStorage = getStorege(
      '@mais/delivery/shop/request/cart/filter/payment',
    );

    try {
      createloading(true);
      const [
        resultTypeDelivery,
        resultHaveCoupon,
        resultListCoupon,
        resultTypePayment,
        resultConfigShop,
        resultCashBackBalance,
      ]: any = await Promise.all([
        api.apiMaisdelivery.shop.getParamsShop({
          nr_operacao: 29,
          idRestaurante: window.atob(idRestaurante),
        }),
        api.apiMaisdelivery.shop.getParamsShop({
          nr_operacao: 30,
          idRestaurante: window.atob(idRestaurante),
        }),
        api.apiMaisdelivery.shop.getParamsShop({
          nr_operacao: 34,
          idRestaurante: window.atob(idRestaurante),
          idUsuario: siginContext.data.user?.idUsuario || 0,
        }),
        api.apiMaisdelivery.shop.getParamsShop({
          nr_operacao: 31,
          idRestaurante: window.atob(idRestaurante),
          idPagamentoForma: 0,
          dsFiltroPagamentoCupom: filterPaymentStorage?.dsFiltroPagamento || 0,
        }),
        api.apiMaisdelivery.shop.getParamsShop({
          nr_operacao: 32,
          idRestaurante: window.atob(idRestaurante),
        }),
        siginContext.data.user?.idUsuario &&
          api.apiMaisdelivery.shop.getParamsShop({
            nr_operacao: 78,
            idMarketplace: shopContext.data.shop.idMarketplace,
            idRestaurante: window.atob(idRestaurante),
            idUsuario: siginContext.data.user?.idUsuario,
          }),
      ]);

      setTypeDelivery(resultTypeDelivery.data);
      setHaveCoupon(resultHaveCoupon.data);
      setListCoupon(resultListCoupon.data);

      let newTypePayment: [] = resultTypePayment.data;

      const resultDataCart = getStorege(
        '@mais/delivery/shop/request/data/cart',
      );

      if (resultTypePayment.data.length > 0 && resultDataCart?.noLogin) {
        newTypePayment = resultTypePayment.data.filter(
          (item: any) => item.idPagamentoForma != 2,
        ) as [];
      }
      setTypePayment(newTypePayment);

      setConfigShop(resultConfigShop.data);
      setCashBackBalance(resultCashBackBalance?.data ?? {});

      createloading(false);
    } catch (error) {
      console.log(error);
      createloading(false);
      toast.error('Ocorreu um erro ao buscar paramentos do estabelecimento');
    }
  };

  const handleLookForPaymentMethodAgain = async (
    data: string,
  ): Promise<void> => {
    try {
      createloading(true);
      const resultTypePayment: any =
        await api.apiMaisdelivery.shop.getParamsShop({
          nr_operacao: 31,
          idRestaurante: window.atob(idRestaurante),
          idPagamentoForma: 0,
          dsFiltroPagamentoCupom: data,
        });

      setTypePayment(resultTypePayment.data);

      createloading(false);
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao buscar formas de pagamento');
    }
  };

  const handleValidationCoupon = async (
    coupon: string,
    cashback = false,
  ): Promise<any> => {
    createloading(true);
    setOpenModalInsertCoupom(false);
    setOpenModalListCoupom(false);
    const isUserAuthenticated = checkUserAutentication();

    if (!isUserAuthenticated) {
      return false;
    }
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.getParamsShop({
          nr_operacao: 35,
          idUsuario: siginContext.data.user?.idUsuario,
          idRestaurante: window.atob(idRestaurante),
          dsCupom: coupon,
          vlPedido: dataRequest.vlPedido,
          idEntrega: dataRequest.idEntrega,
        });
      createloading(false);

      if (result.data?.length > 0) {
        if (
          dataRequest.flgFreteGratis == 1 &&
          result.data[0]?.flgFreteGratis == 1
        ) {
          return false;
        }

        setTextModal({
          title: 'Desconto',
          description: result.data[0].dsMensagem,
          action: cashback,
        });
        setDataRequest((field: any) => {
          return {
            ...field,
            idCupom: result.data[0].idCupom,
            dsCupom: coupon,
            dsMensagemCupom: result.data[0].dsMensagem,
            vlCupom: result.data[0].vlCalculoDesconto,
            idEntregaCupom: result.data[0].idEntrega,
            flgFreteGratis: result.data[0]?.flgFreteGratis,
            flgFreteGratisCupom: result.data[0]?.flgFreteGratis,
            vlEntrega:
              result.data[0]?.flgFreteGratis == 1 ? 0 : dataRequest.vlEntrega,
          };
        });
        setOpenErrorModal(true);

        handleLookForPaymentMethodAgain(
          result.data[0].dsFiltroPagamento || '0',
        );

        saveStorege('@mais/delivery/shop/request/cart/filter/payment', {
          dsFiltroPagamento: result.data[0].dsFiltroPagamento || '0',
        });

        const des_filter_payment_coupon =
          result.data[0].dsFiltroPagamento.split(',');

        if (des_filter_payment_coupon[0] > 0 && dataRequest.idPagamento) {
          if (
            !des_filter_payment_coupon.includes(
              dataRequest.idPagamento.toString(),
            )
          ) {
            setDesNameBtnSend('Enviar pedido');

            setDataRequest((field: any) => {
              return {
                ...field,
                flgPix: 0,
                idPagamento: null,
                dsPagamento: '',
                dsTpChavePix: '',
                dsChavePix: '',
                dsTroco: '',
                idPagamentoForma: null,
              };
            });

            setTextModal({
              title: 'Atenção',
              description:
                'Esse cupom pertence a uma forma de pagamento específica. Por favor, selecione novamente a forma de pagamento.',
            });
            setOpenErrorModal(true);
          }
        }

        setProducts((field: any) => {
          return {
            ...field,
            pedido: {
              idRestaurante: window.atob(idRestaurante),
              idCupom: result.data[0].idCupom,
              dsCupom: coupon,
              dsMensagemCupom: result.data[0].dsMensagem,
              vlCupom: result.data[0].vlCalculoDesconto,
              idEntregaCupom: result.data[0].idEntrega,
            },
          };
        });

        return false;
      }
      if (result.data?.length == 0) {
        setTextModal({
          title: 'Atenção',
          description: `Cupom inválido. Verifique se o cupom foi digitado correntamente e tente novamente.`,
        });
        setOpenErrorModal(true);
        return false;
      }

      if (result.data?.retorno == 'NOK') {
        setTextModal({
          title: 'Atenção',
          description: result.data?.mensagem,
        });
        setOpenErrorModal(true);
        return false;
      }
      toast.error('Ocorreu um erro ao validar seu cupom');
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao validar seu cupom');
    }
  };

  const handleGeneretionCupom = async (): Promise<void> => {
    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.getValueDelivery({
          nr_operacao: 79,
          idMarketplace: shopContext.data.shop.idMarketplace,
          idRestaurante: dataRequest.idRestaurante,
          idUsuario: siginContext.data.user?.idUsuario,
          vlTotal: dataRequest.vlPedido,
        });

      createloading(false);

      if (result.data?.retorno == 'OK') {
        await handleValidationCoupon(result.data?.dsCupom, true);
        return;
      }
    } catch (error) {
      createloading(false);
    }
  };

  const getValueDelivery = async (): Promise<void> => {
    createloading(true);
    if (dataRequest.idEndereco > 0 || dataUserOrder?.dsRua) {
      try {
        const result: ItypeReturnApi =
          await api.apiMaisdelivery.shop.getValueDelivery({
            nr_operacao: dataRequest.idEndereco ? 28 : 83,
            idRestaurante:
              dataRequest.idRestaurante || shopContext.data.shop.idRestaurante,
            idEndereco: dataRequest.idEndereco,
            vlTotalPedido: dataRequest.vlPedido,
            ...dataUserOrder,
            flgLancado: 0,
          });

        createloading(false);
        if (result.data.vlEntrega == -1) {
          handleSetDataRequest('delivery', {
            vlEntrega: 0,
            idEndereco: 0,
            dsEntrega: '',
            vlEntregaOriginal: 0,
          });

          setDataUserOrder((field: any) => {
            return {
              ...field,
              complet: '',
              idEndereco: 0,
              dsRua: '',
              nrRua: '',
            };
          });

          setTextModal({
            title: 'Atenção',
            description: `O seu endereço não está dentro da área de entrega neste momento, por favor selecione o seu pedido para retirada no balcão.`,
          });

          setOpenErrorModal(true);
          return;
        }

        if (
          result.data?.freteGratis == false &&
          result.data?.vlFaltaFreteGratis > 0 &&
          dataRequest.flgFreteGratisCupom != 1
        ) {
          setDataRequest((field: any) => {
            return {
              ...field,
              vlEntrega:
                dataRequest.flgFreteGratis == 1 &&
                result.data.vlFaltaFreteGratis == 0
                  ? 0
                  : result.data.vlEntrega,
              vlEntregaOriginal: result.data.vlEntregaOriginal,
              vlFaltaFreteGratis: result.data.vlFaltaFreteGratis,
            };
          });

          setShowModalFreeDelivery(true);
          setOpenModalAddItem(true);
          return;
        }

        if (
          result.data?.freteGratis == false &&
          result.data?.flgBairroForaFreteGratis == 1 &&
          dataRequest.flgFreteGratisCupom != 1
        ) {
          setDataRequest((field: any) => {
            return {
              ...field,
              vlEntrega: result.data.vlEntrega,
              vlEntregaOriginal: result.data.vlEntregaOriginal,
              vlFaltaFreteGratis: result.data.vlFaltaFreteGratis,
            };
          });
          if (showModalDistrictNoFreeDelivery === true) {
            setTextModal({
              title: 'ATENÇÃO!',
              description: `O seu bairro não faz parte da promoçao de frete grátis.`,
            });
            setShowModalDistrictNoFreeDelivery(false);
            setOpenErrorModal(true);
          }
          return;
        }

        if (
          result.data?.freteGratis == true &&
          result.data?.vlFaltaFreteGratis > 0 &&
          dataRequest.flgFreteGratisCupom != 1
        ) {
          setDataRequest((field: any) => {
            return {
              ...field,
              vlEntrega:
                dataRequest.flgFreteGratis == 1 &&
                result.data.vlFaltaFreteGratis == 0
                  ? 0
                  : result.data.vlEntrega,
              vlEntregaOriginal: result.data.vlEntregaOriginal,
              vlFaltaFreteGratis: result.data.vlFaltaFreteGratis,
            };
          });

          setShowModalFreeDelivery(true);
          setOpenModalAddItem(true);
          return;
        }

        if (
          result.data.freteGratis == true &&
          showModalFreeDelivery === true &&
          dataRequest.flgFreteGratisCupom != 1
        ) {
          setOpenModalAddItem(false);
          setShowModalFreeDelivery(false);

          setTextModal({
            title: 'Parabéns!',
            description: `Você ganhou o frete grátis!`,
          });
          setOpenErrorModal(true);
        }

        if (products?.promotionDeliveryFree == '1') {
          setTextModal({
            title: 'Parabéns!',
            description: `Você ganhou o frete grátis da promoção!`,
          });

          setOpenErrorModal(true);
        }

        setDataRequest((field: any) => {
          return {
            ...field,
            vlEntrega:
              products?.promotionDeliveryFree == '1' ||
              dataRequest.flgFreteGratisCupom == 1
                ? '0.00'
                : result.data.vlEntrega,
            vlEntregaOriginal: result.data.vlEntregaOriginal,
            flgFreteGratis:
              result.data.freteGratis == true || products?.promotionDeliveryFree
                ? 1
                : 0,
          };
        });
      } catch (error) {
        createloading(false);
        toast.error('Ocorreu um erro ao buscar valor do frete');
      }
    }
    createloading(false);
  };

  const handleRemoveCupom = (): void => {
    removeStorege('@mais/delivery/shop/request/cart/filter/payment');

    const freeDeliveryCupom = dataRequest.flgFreteGratisCupom;

    setDataRequest((field: any) => {
      return {
        ...field,
        idRestaurante: window.atob(idRestaurante),
        idCupom: 0,
        dsCupom: '',
        dsMensagemCupom: '',
        vlCupom: 0,
        idEntregaCupom: 0,
        flgFreteGratis:
          freeDeliveryCupom == 1 ? null : dataRequest.flgFreteGratis,
        flgFreteGratisCupom: null,
      };
    });
    setProducts((field: any) => {
      return {
        ...field,
        pedido: {
          idRestaurante: window.atob(idRestaurante),
          idCupom: 0,
          dsCupom: '',
          dsMensagemCupom: '',
          vlCupom: 0,
          idEntregaCupom: 0,
          flgFreteGratis:
            freeDeliveryCupom == 1 ? null : dataRequest.flgFreteGratis,
          flgFreteGratisCupom: null,
        },
      };
    });

    handleLookForPaymentMethodAgain('0');
  };

  const handleClearCupomSelectDelivery = (type: number): void => {
    handleRemoveCupom();

    setOpenModalConfirmAction(false);
    handleSelectTypeDelievry(type, false);
  };

  const handleOpenModalFormatPayment = async (): Promise<void> => {
    setOpenModalFormatPayment(true);
  };

  const getOldOrder = async (
    idUsuario: number,
    idCupom: any,
  ): Promise<void> => {
    try {
      const isUserAuthenticated = checkUserAutentication();

      if (!isUserAuthenticated) {
        return;
      }

      const { data }: ItypeReturnApi =
        await api.apiMaisdelivery.auth.getDataUser({
          nr_operacao: 75,
          idUsuario,
          idMarketplace: shopContext.data.shop.idMarketplace,
          idRestaurante: shopContext.data.shop.idRestaurante,
          idCupom,
        });

      if (data?.idEndereco && data?.arrEndereco.length > 0) {
        handleSetDataRequest('delivery', {
          vlEntrega: 0,
          idEndereco: data.arrEndereco[0].idEndereco,
          dsEntrega: `${data.arrEndereco[0].dsRua} ${data.arrEndereco[0].nrRua}`,
        });
      }

      if (data?.idPagamento && data?.arrPagamento.length > 0) {
        handleSetDataRequest(
          'typePayment',
          {
            idPagamento: data.arrPagamento[0].idPagamento,
            dsPagamento: data.arrPagamento[0].dsPagamento,
            dsTpChavePix: data.arrPagamento[0].dsTpChavePix,
            idPagamentoForma: data.arrPagamento[0].idPagamentoForma,
            flgPix: data.arrPagamento[0].flgPix,
            dsChavePix: data.arrPagamento[0].dsChavePix,
          },
          false,
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkAutenticationSuggetionPayment = (): void => {
    const newTypePayment = typePayment.filter(
      (item: any) => item.idPagamentoForma != 2,
    );

    if (
      !siginContext.signed &&
      newTypePayment.length > 0 &&
      !dataRequest.noLogin
    ) {
      setDesNameBtnSend('Continuar');
      setOpenModalChoosePaymentMethod(true);
    }
  };

  const handleTreatPayment = (): void => {
    const newTypePayment: [] = typePayment.filter(
      (item: any) => item.idPagamentoForma != 2,
    ) as [];

    setDataRequest((field: any) => {
      return {
        ...field,
        flgPix: 0,
        idPagamento: null,
        dsPagamento: '',
        dsTpChavePix: '',
        dsChavePix: '',
        dsTroco: '',
        idPagamentoForma: null,
        noLogin: true,
        vlEntrega: 0,
        idEndereco: 0,
        dsEntrega: '',
      };
    });

    dataRequest.flgPix = 0;
    dataRequest.idPagamento = null;
    dataRequest.dsPagamento = '';
    dataRequest.dsTpChavePix = '';
    dataRequest.dsChavePix = '';
    dataRequest.dsTroco = '';
    dataRequest.idPagamentoForma = null;
    dataRequest.noLogin = true;
    dataRequest.vlEntrega = 0;
    dataRequest.idEndereco = 0;
    dataRequest.dsEntrega = '';

    saveStorege('@mais/delivery/shop/request/data/cart', dataRequest);

    setTypePayment(newTypePayment);
    handleOpenModalFormatPayment();
  };

  useEffect(() => {
    const result = getStorege('@mais/delivery/shop/request/product/cart');

    if (!result) {
      handleToPage(`/shop/detail/list/product/subcategorie/${idRestaurante}`);
    }
    setProducts(result);
  }, [siginContext.data.user]);

  useEffect(() => {
    async function CalcProduct(): Promise<void> {
      if (products?.pedido_cardapio.length > 0) {
        products.pedido.idUsuario = siginContext.data.user?.idUsuario;
        products.pedido.idEntrega = dataRequest.idEntrega;
        try {
          const result: ItypeReturnApi =
            await api.apiMaisdelivery.shop.getResultCalcVlCart({
              nr_operacao: 27,
              idUsuario: siginContext.data.user?.idUsuario,
              ...products,
            });

          setDataRequest((field: any) => {
            return {
              ...field,
              vlPedido: result.data?.valor_total,
              vlDesconto: result.data?.valor_desconto,
              vlEntrega:
                result.data?.frete_gratis == 1 ? 0 : dataRequest.vlEntrega,
            };
          });
        } catch (error) {
          toast.error(
            'Ocorreu um erro ao buscar valor total do pedido em andamento',
          );
        }
      }
    }
    CalcProduct();
  }, [products]);

  useEffect(() => {
    const result = getStorege('@mais/delivery/address/create/request');

    if (
      (result?.id_shop ? window.atob(result?.id_shop) : '') ===
      window.atob(idRestaurante)
    ) {
      handleSetDataRequest('delivery', {
        vlEntrega: 0,
        idEndereco: result.idEndereco,
        dsEntrega: result.dsEntrega,
      });
    }
    getValueDelivery();
    removeStorege('@mais/delivery/address/create/request');
  }, []);

  useEffect(() => {
    handleGetParamsShop();
  }, [siginContext.data.user]);

  useEffect(() => {
    async function CloseModal(): Promise<void> {
      if (openErrorModal) {
        await new Promise((resolve) => {
          setTimeout(resolve, 5000);
        });
        setOpenErrorModal(false);
        setTextModal({
          title: '',
          description: '',
        });
      }
    }
    CloseModal();
  }, [openErrorModal]);

  useEffect(() => {
    const result = getStorege('@mais/delivery/shop/request/data/cart');
    if (result) {
      setDataRequest(result);
    }
    setUseFn(false);
  }, []);

  useEffect(() => {
    if (products?.pedido?.idCupom) {
      saveStorege('@mais/delivery/shop/request/product/cart', products);
    }
  }, [products?.pedido]);

  useEffect(() => {
    if (!useFn) {
      if (siginContext.data?.user?.idUsuario && idRestaurante) {
        const dataUserStorage = getStorege('@mais/delivery/user');

        dataRequest.idUsuario = siginContext.data.user.idUsuario;
        dataRequest.dsCpf =
          onlyNumbers(cpf) || onlyNumbers(dataUserStorage?.dsCpf);
        dataRequest.idRestaurante = window.atob(idRestaurante);
      }
      dataRequest.idRestaurante = shopContext.data.shop.idRestaurante;
      setDataRequest(dataRequest);

      if (dataRequest.noLogin && !dataUserOrder?.dsNome) {
        setDesNameBtnSend('Continuar');
      }

      saveStorege('@mais/delivery/shop/request/data/cart', dataRequest);
    }
  }, [dataRequest, siginContext.data.user, idRestaurante]);

  useEffect(() => {
    if (
      products?.pedido_cardapio.filter(
        (item: any) =>
          item?.idPromocao !== null &&
          item.idPromocao !== undefined &&
          item.idPromocao.trim() !== '',
      )[0]
    ) {
      setHaveIsPromotion(true);

      const filterPaymentStorage = getStorege(
        '@mais/delivery/shop/request/cart/filter/payment',
      );
      if (filterPaymentStorage?.dsFiltroPagamento != null) {
        const des_filter_payment_promotion =
          filterPaymentStorage.dsFiltroPagamento.split(',');

        if (des_filter_payment_promotion[0] > 0 && dataRequest.idPagamento) {
          if (
            !des_filter_payment_promotion.includes(
              dataRequest.idPagamento.toString(),
            )
          ) {
            setDesNameBtnSend('Enviar pedido');

            setDataRequest((field: any) => {
              return {
                ...field,
                flgPix: 0,
                idPagamento: null,
                dsPagamento: '',
                dsTpChavePix: '',
                dsChavePix: '',
                dsTroco: '',
                idPagamentoForma: null,
              };
            });

            setTextModal({
              title: 'Atenção',
              description:
                'Esta promoção pertence a uma forma de pagamento específica. Por favor, selecione novamente a forma de pagamento.',
            });
            setOpenErrorModal(true);
          }
        }
      }
    }
    if (products?.dateTimeRequest) {
      const checkDateTime = checkCartStorege(products.dateTimeRequest, 25);
      if (checkDateTime) {
        toast.info(
          'Seu carrinho expirou, por favor faça seu pedido novamente.',
        );
        handleToPage(`/shop/detail/list/product/subcategorie/${idRestaurante}`);
      }
    }
  }, [products]);

  useEffect(() => {
    (async () => {
      const result = getStorege('@mais/delivery/shop/request/data/cart');

      if (
        siginContext.data.user?.idUsuario &&
        !result?.idEndereco &&
        !result?.idPagamento
      ) {
        await getOldOrder(siginContext.data.user.idUsuario, result?.idCupom);
      }
    })();
  }, [siginContext.data.user]);

  useEffect(() => {
    getValueDelivery();
  }, [
    dataRequest.idEndereco,
    dataRequest.vlPedido,
    dataRequest.flgFreteGratisCupom,
    dataUserOrder?.dsRua,
  ]);

  useEffect(() => {
    if (
      parseCurrencyBRToFloat(String(dataRequest.vlPedido)) +
        parseCurrencyBRToFloat(String(dataRequest.vlEntrega)) >
        parseCurrencyBRToFloat(String(dataRequest.vlTroco)) ||
      dataRequest.vlTroco == -1
    ) {
      setDataRequest((field: any) => {
        return {
          ...field,
          vlTroco: null,
          dsTroco: '',
        };
      });
    }
  }, [dataRequest.vlPedido, dataRequest.vlEntrega]);

  useEffect(() => {
    checkAutenticationSuggetionPayment();
  }, [siginContext.signed, typePayment]);

  useEffect(() => {
    trackEvent('InitiateCheckout');
  }, []);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      {products && shopContext.data.shop && (
        <>
          <Header children="DetailRequest" />
          <CssBaseline />
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            marginBottom="50px"
          >
            <Grid className={classeStyle.gridMain}>
              <h3>Finalizar Pedido</h3>

              <>
                <Grid
                  className={classeStyle.gridLocation}
                  style={
                    dataRequest.dsEntrega
                      ? { backgroundColor: '#ffffff', padding: '5px 10px' }
                      : { backgroundColor: '#fbd3d3', padding: '5px 10px' }
                  }
                >
                  <Grid container item alignItems="center">
                    <Grid margin="5px">
                      <IconLocation />
                    </Grid>
                    <Grid>
                      <h5 className={classeStyle.titleLocation}>
                        {dataRequest.dsEntrega
                          ? dataRequest.dsEntrega
                          : 'Defina o endereço de entrega'}
                      </h5>
                      <p className={classeStyle.textDesLocation}>
                        Entrega: {shopContext.data.shop?.dsTempo}
                      </p>
                    </Grid>
                  </Grid>

                  <Grid
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleTypeDeliveryExec(typeDelivery)}
                  >
                    <p
                      style={{
                        color: '#ab3631',
                        fontWeight: 600,
                        margin: 0,
                        fontSize: 14,
                      }}
                    >
                      {dataRequest.dsEntrega ? 'Trocar' : 'Definir'}
                    </p>
                  </Grid>
                </Grid>
                <TypeDeliveryModal
                  open={openModalTypeDelivery}
                  onClose={() => setOpenModalTypeDelivery(false)}
                  handleTypeDelivery={handleSelectTypeDelievry}
                />
                <ListCenterOrder
                  open={openModalAddressSelect}
                  onClose={() => setOpenModalAddressSelect(false)}
                  title="Endereço de entrega"
                  dataList={addresses}
                  type="endereco"
                  onSelect={(data) =>
                    handleSetDataRequest('delivery', {
                      vlEntrega: 0,
                      idEndereco: data.idEndereco,
                      dsEntrega: `${data.dsRua} ${data.nrRua}`,
                    })
                  }
                  showAddButton
                  onAddNew={() =>
                    handleToPage(
                      `/dashboard/user/address/create/${window.btoa(
                        'requestProgress',
                      )}/${idRestaurante}`,
                    )
                  }
                />
              </>

              <hr className={classeStyle.hr} />
              <Grid>
                {products.pedido_cardapio.length > 0 &&
                  products.pedido_cardapio.map((item: any) => (
                    <Grid
                      className={classeStyle.gridProduct}
                      key={item.idCardapio + item.idPedidoCardapio}
                    >
                      <Grid className={classeStyle.gridBannerAndDes}>
                        {item.dsImagem && (
                          <img
                            src={`${
                              process.env.REACT_APP_API_IMG + item.dsImagem
                            }`}
                            alt="banner"
                            className={classeStyle.bannerProduct}
                          />
                        )}
                        <Grid marginLeft="10px" width="100%">
                          <h5 className={classeStyle.titleProduct}>
                            {item.dsNome}
                          </h5>
                          <Grid>
                            {products?.sabor?.length > 0 &&
                              products.sabor
                                .filter(
                                  (flavorItem: any) =>
                                    Number(flavorItem.idPedidoCardapio) ===
                                    Number(item.idPedidoCardapio),
                                )
                                .map((flavorItem: any) => (
                                  <p
                                    className={classeStyle.textDesProduct}
                                    key={flavorItem.idSabor}
                                  >
                                    * {flavorItem.dsSabor}
                                  </p>
                                ))}
                            {products?.adicional?.length > 0 &&
                              products.adicional
                                .filter(
                                  (additionalItem: any) =>
                                    Number(additionalItem.idPedidoCardapio) ===
                                    Number(item.idPedidoCardapio),
                                )
                                .map((additionalItem: any) => (
                                  <p
                                    className={classeStyle.textDesProduct}
                                    key={additionalItem.idAdicional}
                                  >
                                    * {additionalItem.qtItens}x{' '}
                                    {additionalItem.dsNome}
                                  </p>
                                ))}
                            {products?.opcoes?.length > 0 &&
                              products.opcoes
                                .filter(
                                  (optionLevelItem: any) =>
                                    Number(optionLevelItem.idPedidoCardapio) ===
                                    Number(item.idPedidoCardapio),
                                )
                                .map((optionLevelItem: any) => (
                                  <p
                                    className={classeStyle.textDesProduct}
                                    key={optionLevelItem.idOpcaoNivel}
                                  >
                                    * {optionLevelItem.qtItens}x{' '}
                                    {optionLevelItem.dsNome}
                                  </p>
                                ))}
                          </Grid>
                          <Grid className={classeStyle.gridVlQtProduct}>
                            <p className={classeStyle.textVlProduct}>
                              R$ {FormatPrice(item.vlItemTotal)}
                            </p>
                            <Grid
                              className={classeStyle.gridIncrementQtProduct}
                            >
                              <IconLess
                                onClick={() =>
                                  handleSetQtProduct(
                                    item.idCardapio,
                                    item.idPedidoCardapio,
                                    item.qtItens - 1,
                                    item?.idPromocao,
                                    item?.promotionMaxStage,
                                  )
                                }
                              />
                              <p className={classeStyle.textQtProduct}>
                                {item?.qtItens}
                              </p>
                              <IconPlus1
                                onClick={() =>
                                  handleSetQtProduct(
                                    item.idCardapio,
                                    item.idPedidoCardapio,
                                    item.qtItens + 1,
                                    item?.idPromocao,
                                    item?.promotionMaxStage,
                                  )
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
              </Grid>
              <hr className={classeStyle.hr} />
              <Grid
                className={classeStyle.gridCuopom}
                onClick={() => handleShowModalCoupom(1)}
                style={
                  // eslint-disable-next-line no-nested-ternary
                  haveCoupon?.flgCupom == 1 &&
                  !haveIsPromotion &&
                  !dataRequest.noLogin
                    ? dataRequest.dsMensagemCupom
                      ? {
                          backgroundColor: '#ffffff',
                          padding: '5px 10px',
                          display: 'flex',
                        }
                      : {
                          backgroundColor: '#fbd3d3',
                          padding: '5px 10px',
                          display: 'flex',
                        }
                    : { display: 'none' }
                }
              >
                <Grid style={{ display: 'flex', alignItems: 'center' }}>
                  <Grid className={classeStyle.gridIconCuopom}>
                    <IconCoupon />
                  </Grid>
                  <Grid>
                    {dataRequest.dsMensagemCupom ? (
                      <p className={classeStyle.textDesCuopom}>
                        {dataRequest.dsMensagemCupom}
                      </p>
                    ) : (
                      <p className={classeStyle.textDesCuopom}>
                        Cupom de desconto
                      </p>
                    )}
                  </Grid>
                </Grid>

                <Grid style={{ cursor: 'pointer' }}>
                  <p
                    style={{
                      color: '#ab3631',
                      fontWeight: 600,
                      margin: 0,
                      fontSize: 14,
                    }}
                  >
                    {dataRequest.dsMensagemCupom ? 'Trocar' : 'Definir'}
                  </p>
                </Grid>
              </Grid>
              {haveCoupon?.flgCupom == 1 && !haveIsPromotion && (
                <hr className={classeStyle.hr} />
              )}
              <ListCenterOrder
                open={openModalListCoupom}
                onClose={() => setOpenModalListCoupom(false)}
                title="Cupons de desconto"
                dataList={listCoupon}
                type="cupom"
                onSelect={(dataListCoupon: any) =>
                  handleValidationCoupon(dataListCoupon.dsCupom, false)
                }
                extraTopItem={{
                  key: 'digitar-cupom',
                  primary: 'Digitar o nome do cupom',
                  onClick: () => handleShowModalCoupom(2),
                  icon: <IconRight width={15} height={15} />,
                }}
                extraBottomItem={
                  dataRequest.dsMensagemCupom
                    ? {
                        key: 'remover-cupom',
                        primary: 'Remover cupom',
                        onClick: () => {
                          handleRemoveCupom();
                          setOpenModalListCoupom(false);
                        },
                        icon: <IconRight width={15} height={15} />,
                      }
                    : undefined
                }
              />
              <ModalInput
                isOpen={openModalInsertCoupom}
                title="Inserir seu cupom"
                placeholder="Cupom"
                inputType="text"
                icon={<IconCoupon1 className={classeStyle.iconModal} />}
                handleFn={(value) => handleValidationCoupon(value, true)}
                btnNamePrimary="VALIDAR"
                onClose={() => setOpenModalInsertCoupom(false)}
              />
              <Grid>
                <h4>Resumo do pedido:</h4>
                <Grid className={classeStyle.gridValues}>
                  <Grid className={classeStyle.gridValue}>
                    <p className={classeStyle.textDesValue}>Produtos</p>
                    <p className={classeStyle.textVlValue}>
                      R$ {FormatPrice(dataRequest.vlPedido || 0)}
                    </p>
                  </Grid>
                  <Grid className={classeStyle.gridValue}>
                    <p className={classeStyle.textDesValue}>Desconto cupom</p>
                    <p
                      className={classeStyle.textVlValue}
                      style={{ color: '#004180' }}
                    >
                      R$ {FormatPrice(parseFloat(dataRequest.vlDesconto))}
                    </p>
                  </Grid>
                  <Grid className={classeStyle.gridValue}>
                    <p className={classeStyle.textDesValue}>Taxa de entrega</p>
                    <p className={classeStyle.textVlValue}>
                      R$ {FormatPrice(dataRequest.vlEntrega)}
                    </p>
                  </Grid>
                </Grid>
                <Grid className={classeStyle.gridTotalValue}>
                  <h3 className={classeStyle.titleTotalValue}>Total</h3>
                  <h3 className={classeStyle.textVlTotalValue}>
                    R${' '}
                    {FormatPrice(
                      parseFloat(dataRequest.vlPedido) +
                        parseFloat(dataRequest.vlEntrega),
                    )}
                  </h3>
                </Grid>
              </Grid>
              <hr className={classeStyle.hr} />
              {shopContext.data.shop.vlMinimo >
                parseFloat(dataRequest.vlPedido) +
                  parseFloat(dataRequest.vlEntrega) && (
                <Grid container justifyContent="center">
                  <h5 className={classeStyle.textVlTotalValue}>
                    Falta pouco! O pedido mínimo é de R${' '}
                    {FormatPrice(shopContext.data.shop.vlMinimo)}
                  </h5>
                  <hr className={classeStyle.hr} />
                </Grid>
              )}
              <Grid
                className={classeStyle.gridFormatPayment}
                style={
                  dataRequest.dsPagamento
                    ? { backgroundColor: '#ffffff', padding: '5px 10px' }
                    : { backgroundColor: '#fbd3d3', padding: '5px 10px' }
                }
              >
                <Grid
                  container
                  item
                  alignItems="center"
                  onClick={() => handleOpenModalFormatPayment()}
                >
                  <Grid margin="5px">
                    <Grid className={classeStyle.gridIconFormatPayment}>
                      <IconWallet />
                    </Grid>
                  </Grid>
                  <Grid>
                    <p className={classeStyle.textDesFormatPayment}>
                      {dataRequest?.dsPagamento
                        ? dataRequest.flgPix == 1
                          ? `${dataRequest.dsPagamento}`
                          : dataRequest.dsPagamento
                        : 'Escolher forma de pagamento'}{' '}
                      {dataRequest?.dsTroco && dataRequest.dsTroco}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleOpenModalFormatPayment()}
                >
                  <p
                    style={{
                      color: '#ab3631',
                      fontWeight: 600,
                      margin: 0,
                      fontSize: 14,
                    }}
                  >
                    {dataRequest.dsPagamento ? 'Trocar' : 'Definir'}
                  </p>
                </Grid>
              </Grid>

              <ListCenterOrder
                open={openModalFormatPayment}
                onClose={() => setOpenModalFormatPayment(false)}
                title="Formas de pagamento"
                dataList={typePayment}
                type="pagamento"
                onSelect={(data) =>
                  handleSetDataRequest('typePayment', {
                    idPagamento: data.idPagamento,
                    dsPagamento: data.dsPagamento,
                    dsTpChavePix: data.dsTpChavePix,
                    idPagamentoForma: data.idPagamentoForma,
                    flgPix: data.flgPix,
                    dsChavePix: data.dsChavePix,
                  })
                }
              />

              {configShop?.length > 0 &&
                parseInt(configShop[0]?.flgCpfObrigato, 10) === 1 && (
                  <>
                    <Grid
                      marginTop="20px"
                      className={classeStyle.gridFormatPayment}
                      style={
                        dataRequest.dsCpf
                          ? { backgroundColor: '#ffffff', padding: '2px 10px' }
                          : { backgroundColor: '#fbd3d3', padding: '2px 10px' }
                      }
                    >
                      <Grid
                        container
                        item
                        alignItems="center"
                        onClick={() => handleModalInputFooter(true, 'cpf')}
                      >
                        <Grid margin="5px">
                          <Grid className={classeStyle.gridIconFormatPayment}>
                            <img
                              style={{ width: 18 }}
                              src={imgCpf}
                              alt="icon"
                            />
                          </Grid>
                        </Grid>
                        <Grid>
                          <p className={classeStyle.textDesFormatPayment}>
                            {FormatCpf(dataRequest.dsCpf) || 'Informe seu CPF'}
                          </p>
                        </Grid>
                      </Grid>
                      <Grid
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleModalInputFooter(true, 'cpf')}
                      >
                        <p
                          style={{
                            color: '#ab3631',
                            fontWeight: 600,
                            margin: 0,
                            fontSize: 14,
                          }}
                        >
                          {dataRequest.dsCpf ? 'Trocar' : 'Definir'}
                        </p>
                      </Grid>
                    </Grid>
                  </>
                )}
              <Grid className={classeStyle.gridObservationMain}>
                <Grid className={classeStyle.gridObservation}>
                  <IconObservation />
                  <h4 className={classeStyle.titleObservation}>
                    Alguma observação?
                  </h4>
                </Grid>
                <hr className={classeStyle.hrObs} />

                <Grid>
                  <textarea
                    className={classeStyle.textArea}
                    style={{ height: 60 }}
                    placeholder=""
                    onChange={(e: any) =>
                      handleSetDataRequest('dsObservacaoLocal', e.target.value)
                    }
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                justifyContent="center"
                marginTop="15px"
              >
                <Button
                  className={classeStyle.btnSubmit}
                  style={{
                    position: 'fixed',
                    bottom: 5,
                    width: '80%',
                    maxWidth: '680px',
                  }}
                  variant="contained"
                  onClick={() => handleTreatRequestInit()}
                >
                  {desNameBtnSend}
                  <IconArrowRight className={classeStyle.iconArrow} />
                </Button>
              </Grid>
              <ConfirmOrderModal
                open={openModalConfirmRequest}
                onClose={() => setOpenModalConfirmRequest(false)}
                dataRequest={dataRequest}
                shopAddress={shopContext.data.shop.dsEndereco}
                handleSendRequest={handleSendRequest}
                desNameBtnSend={desNameBtnSend}
              />
              <ModalMessage
                open={openUserNotParams}
                onClose={() => setOpenUserNotParams(false)}
                title="Confirmação!"
                description={errorInfo}
                primaryText="Confirmar"
                primaryAction={() =>
                  handleDeleteItemProduct(productParamDelete)
                }
                secondaryText="Cancelar"
                secondaryAction={() => setOpenUserNotParams(false)}
              />
              <ModalMessage
                open={openErrorModal}
                onClose={() => setOpenErrorModal(false)}
                title={textModal.title}
                description={textModal.description}
                primaryText="Ok"
                primaryAction={() => {
                  if (textModal?.action) {
                    handleTreatRequestInit();
                  }
                }}
              />
              <AddItemCartModal
                open={openModalAddItem}
                onClose={() => setOpenModalAddItem(false)}
                vlFaltaFreteGratis={dataRequest.vlFaltaFreteGratis}
                idRestaurante={idRestaurante}
                handleToPage={handleToPage}
              />
              <SuccessRequestModal
                open={openModalSuccessRequest}
                onClose={() => setOpenModalSuccessRequest(false)}
                flgPix={dataRequest.flgPix}
                idRequest={idRequest}
                idRestaurante={idRestaurante}
                handleToPage={handleToPage}
              />
              <ModalConfirmFooter
                isOpen={openModalConfirmAction}
                title={msgnModalConfirmAction.title}
                message={msgnModalConfirmAction.messagem}
                btnNamePrimary="Confirmar"
                btnNameSecondary=""
                btnCancel="VOLTAR"
                handleFn={async () =>
                  handleClearCupomSelectDelivery(msgnModalConfirmAction.action)
                }
                onClose={() => setOpenModalConfirmAction(false)}
                heightModal="500px"
              />
              <ModalInputFooter
                isOpen={openModalFooterInput}
                data={dataModalFooterInput}
                handleFn={async (value) =>
                  callbackModalInputFooter(value, dataModalFooterInput.type)
                }
                onClose={() => {
                  setOpenModalFooterInput(false);
                }}
              />

              <ModalConfirmFooter
                isOpen={openModalConfirmMajority}
                title="Atenção"
                message="Este produto é destinado a maiores de 18 anos. Você confirma que é maior de idade para comprar?"
                btnNamePrimary="Sim, tenho 18+"
                btnNameSecondary="Não, voltar"
                btnCancel=""
                handleFn={async () => {
                  setConfirmMajority(true);
                  handleTreatRequestInit();
                }}
                handleFn2={async () => setOpenModalConfirmMajority(true)}
                onClose={() => setOpenModalConfirmMajority(false)}
              />

              <ModalImgBackgroundFooter
                isOpen={openModalFooterBenefit}
                title={
                  <>
                    Você já acumulou{' '}
                    <strong>{FormatPrice(cashBackBalance?.vlSaldo)}</strong>
                    <br />
                    em cashback!
                  </>
                }
                message="Quer usar agora para ganhar desconto neste pedido?"
                btnNamePrimary="Quero!"
                imgBackground={imgCashbackIcon}
                handleFn={async () => {
                  handleGeneretionCupom();
                }}
                onClose={() => setOpenModalFooterBenefit(false)}
              />

              <ModalConfirmFooter
                isOpen={openModalChoosePaymentMethod}
                title="Atenção"
                message="Você deseja pagar agora ou quando pedido chegar?"
                btnNamePrimary="Pagar agora"
                btnNameSecondary="Pagar na entrega"
                btnCancel=""
                handleFn={async () => {
                  setOpenModalChoosePaymentMethod(false);
                  handleTreatPayment();
                }}
                handleFn2={async () => {
                  setOpenModalChoosePaymentMethod(false);
                  setDesNameBtnSend('Enviar pedido');
                  removeStorege('@mais/delivery/authorization/orders');
                }}
                onClose={() => ''}
              />

              <OrderDataRegister
                isOpen={openModalOrderRegister}
                dataOrder={dataRequest}
                dataShop={shopContext.data}
                onClose={() => setOpenModalOrderRegister(false)}
                fn={(data) => {
                  setDataUserOrder(data);
                  setDataRequest((field: any) => {
                    return {
                      ...field,
                      idEndereco: data?.idEndereco || 0,
                      idUsuario: data?.idUsuario || 0,
                      idRestaurante: shopContext.data.shop.idRestaurante,
                      dsEntrega:
                        dataRequest.idEntrega == 1
                          ? `${data.dsRua} ${data.nrRua}`
                          : dataRequest.dsEntrega,
                    };
                  });
                  setDesNameBtnSend('Pagar');
                }}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Container>
  );
};

export default Cart;
